<mat-form-field class="w-100">
  <mat-label>{{label}}</mat-label>
  <input type="text"
    matInput
    [formControl]="myControl"
    [matAutocomplete]="auto"
    >
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelect()" [displayWith]="displayFn">
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">{{option.name}}</mat-option>
    }
  </mat-autocomplete>
  @if (myControl.value) {
    <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();myControl.setValue(null);onOptionSelect()"><mat-icon>close</mat-icon></button>
  }
</mat-form-field>
